import axios from 'axios'
import Database from '@/assets/javascript/database'

export default class Main {
  store = null
  router = null

  constructor (store, router) {
    this.store = store
    this.router = router
  }

  enforceAuthentication () {
    // console.log('Handle protected pages in main.js')
    let inRoute = false
    this.router.beforeEach((to, from, next) => {
      inRoute = true
      // console.log('Got router path ' + to.path)
      if (to.path.startsWith('/public')) {
        // console.log('Got a public page')
        next()
      } else if (to.path === '/login') {
        // console.log('Got the login page')
        next()
      } else {
        // console.log('Got a request for a protected page \'' + to.path + '\'')
        if (this.store.state.session.token) {
          // console.log('Access to protected page is granted as a session token is found: ' + this.store.state.session.token)
          next()
        } else {
          // console.log('No session token found, go to login page')
          next('/login')
        }
      }
    })
    if (!inRoute) {
      // console.log('Not in route')
      let path = window.location.pathname
      if (!path.startsWith('/public')) {
        if (!this.store.state.session.token) {
          // Check the session token in local storage
          let token = localStorage.getItem('SessionToken')
          if (token && token !== 'undefined' && token.length >= 0) {
            this.store.dispatch('session/tokenLogin', { token: token })
              .then(() => {
                this.store.dispatch('page/setSidebarItem', { key: 'dashboard' })
                if (this.store.getters['session/hasAdministratorRole']) {
                  this.store.dispatch('app/loadSalesOrganizations')
                }
                this.router.push({name: 'Main'})
              })
              .catch(() => {
                console.log('Failed to login with token, will redirect to login page')
                this.router.push({name: 'Login'})
              })
          } else {
            // console.log('Not in route and not session token found, will redirect to login page')
            this.router.push({name: 'Login'})
          }
        }
      }
    }
  }

  checkSession () {
    // console.log('Check session')
    let online = navigator.onLine
    let store = this.store
    if (store.state.session.token !== '' && online) {
      let instance = this
      axios.get('/backend/rest/session/status')
        .then(response => {
          store.dispatch('session/setConnected', true)
          if (response.data && response.data.version) {
            let version = response.data.version
            let runMode = response.data.runMode
            store.dispatch('status/setApplicationVersionNew', version)
            store.dispatch('status/setRunMode', runMode)
            let currentVersion = store.getters['status/getApplicationVersion']
            if (!currentVersion || currentVersion === '') {
              store.dispatch('status/setApplicationVersion', version)
            }
          }
          store.dispatch('session/setActiveProduction', response.data.production)
          store.dispatch('session/setArchivedProduction', response.data.archivedProduction)
          instance.updateProduction(response.data.production)
        })
        .catch(() => {
          if (store.state.session.token !== '') {
            store.dispatch('session/setConnected', false)
          }
        })
    }
  }

  startSessionChecker () {
    // console.log('Starting session checker')
    let instance = this
    setTimeout(function () {
      instance.checkSession()
    }, 2500)
    setInterval(function () {
      instance.checkSession()
    }, 60000)
  }

  startCommandProcessor () {
    // console.log('Starting command processor')
    let store = this.store
    store.commit('contractor/setProcessing', false)
    setInterval(function () {
      store.dispatch('contractor/checkSendContractorCommands')
    }, 10000)
  }

  updateProduction (activeProduction) {
    // console.log('Check production: ' + (activeProduction ? JSON.stringify(activeProduction) : ''))
    if (activeProduction) {
      let currentProductionName = localStorage.getItem('ProductionName')
      if (!currentProductionName || currentProductionName !== activeProduction.name) {
        console.log('Production has changed from "' + currentProductionName + '" to "' + activeProduction.name + '"')
        localStorage.setItem('ProductionName', activeProduction.name)

        console.log('Clearing local contractor commands')
        let db = new Database()
        db.doInTransaction('ContractorCommands', function (tx) {
          let contractorCommands = tx.objectStore('ContractorCommands')
          if (contractorCommands) {
            contractorCommands.clear()
          }
        })

        console.log('Clearing local pallets in production')
        let palletsInProduction = []
        localStorage.setItem('PalletsInProduction', JSON.stringify(palletsInProduction))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascript/main.js